import { Reveal, SectionHead } from "@/components/ui/motion";

// Only add real testimonials with publication consent.
export const TESTIMONIALS = [];

export const Testimonials = () => {
  if (!TESTIMONIALS.length) return null;
  return (
    <section className="py-20 sm:py-28" data-testid="testimonials-section">
      <div className="wrap">
        <SectionHead eyebrow="Pengalaman Klien" title="Cerita dari mereka yang telah kami dampingi." />
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.06}>
              <figure className="card h-full p-8">
                <blockquote className="text-[16px] leading-relaxed text-ink">“{t.quote}”</blockquote>
                <figcaption className="mt-6 font-display font-bold text-slateb">{t.name}<span className="block text-sm font-medium text-ink-soft">{t.context}</span></figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
